import { UserID } from "./user.interface"
import { CruiseLineId } from "../cruises/cruise-line.interface"
import { HostAgency, HostAgencyID } from "./host-agency.types"
import { AgencyConsortia, AgencyConsortiaID } from "./agency-consortia.types"

export type AgentProfileID = number

export enum AgentPlanEnum {
  LITE = "lite",
  ENTERPRISE = "enterprise",
}

export type AgentPlan = `${AgentPlanEnum}`

export type AgentCruisesOverallVolumePercent = "0-25" | "25-50" | "50-75" | "75-90" | "90+"

export type AgencyCruisesAnnualBookingVolume =
  | "not-disclosed"
  | "0-50k"
  | "50k-100k"
  | "100k-250k"
  | "250k-500k"
  | "500k-1m"
  | "1m+"

export type AgencyPrimaryCustomerAcquisitionMean =
  | "social-media"
  | "word-of-mouth"
  | "advertising"
  | "repeat-business"
  | "other"

export type AgencyGoalsAtCruisen =
  | "save-time"
  | "grow-customers"
  | "gain-customers"
  | "prevent-churn"

export interface IAgentProfile {
  id: AgentProfileID
  userId: UserID
  phoneNumber: string | null
  email: string | null
  agentCode: string
  shortBio: string
  favouriteTravelDestination: string
  bestTravelAdvice: string
  agencyName?: string
  agencyPhoneNumber?: string
  customTerms?: string
  cruisesOverallVolumePercent?: AgentCruisesOverallVolumePercent
  cruisesAnnualBookingVolume?: AgencyCruisesAnnualBookingVolume
  primaryCustomerAcquisitionMean?: AgencyPrimaryCustomerAcquisitionMean
  agencyGoalsAtCruisen?: AgencyGoalsAtCruisen[]
  plan: AgentPlan
  preferredCruiseLineIds: CruiseLineId[]
  agentLink: string
  /** A unique identifier for a host agency, this property is used to associate agent with a specific host agency. */
  hostAgencyId?: HostAgencyID | null
  hostAgency?: HostAgency | null
  /** A unique identifier for an agency consortia, this property is used to associate agent with a specific agency consortia. */
  consortiaId?: AgencyConsortiaID | null
  consortia?: AgencyConsortia | null
  created: Date
  updated: Date
}

export type AgentProfilePayload = Omit<
  IAgentProfile,
  "id" | "userId" | "hostAgency" | "consortia" | "created" | "updated"
> & {
  id?: AgentProfileID
  userId?: UserID
}
